import React, { useMemo } from "react";
import { Line } from "react-chartjs-2";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import moment from "moment";

export const StrategyReport = ({
  amortizationData,
  loading,
  amortizationDataWithNoSnowball,
}) => {
  const { labels, totalBalanceData, totalPaymentData } = useMemo(() => {
    const monthMap = {};
    const dataArray =
      amortizationData &&
      amortizationData.allAmortizationData.modulewiseAmortizationData &&
      Array.isArray(
        amortizationData.allAmortizationData.modulewiseAmortizationData
      )
        ? amortizationData.allAmortizationData.modulewiseAmortizationData
        : [];
    dataArray.forEach((item) => {
      item.amortizationArray.forEach((entry) => {
        const monthLabel = moment(entry.month).format("MM-YYYY");
        if (!monthMap[monthLabel]) {
          monthMap[monthLabel] = { balance: 0, payment: 0 };
        }

        // Add remaining balance and payments for that month
        // monthMap[monthLabel].balance += parseFloat(entry.remainingBalance || 0);
        monthMap[monthLabel].balance += parseFloat(entry.principalPaid || 0);
        monthMap[monthLabel].payment +=
          parseFloat(entry.principalPaid || 0) +
          parseFloat(entry.interestPayment || 0);
      });
    });

    const sortedMonths = Object.keys(monthMap).sort(
      (a, b) => moment(a, "MM-YYYY") - moment(b, "MM-YYYY")
    );

    return {
      labels: sortedMonths || [],
      totalBalanceData: sortedMonths.map((m) => monthMap[m].balance),
      totalPaymentData: sortedMonths.map((m) => monthMap[m].payment),
    };
  }, [amortizationData]);

  // Step 2: Chart.js dataset configuration

  const parseNumber = (value) => (value ? Number(value.replace(/,/g, "")) : 0);

  const monthIndex =
    amortizationData &&
    amortizationData.allAmortizationData &&
    amortizationData.allAmortizationData.amortizationTable.header &&
    amortizationData.allAmortizationData.amortizationTable.header.indexOf(
      "Month"
    );
  const endBalanceIndex =
    amortizationData &&
    amortizationData.allAmortizationData &&
    amortizationData.allAmortizationData.amortizationTable.header &&
    amortizationData.allAmortizationData.amortizationTable.header.indexOf(
      "End Balance"
    );
  const monthsArray =
    amortizationData &&
    amortizationData.allAmortizationData &&
    amortizationData.allAmortizationData.amortizationTable.data &&
    amortizationData.allAmortizationData.amortizationTable.data.map(
      (row) => row[monthIndex]
    );
  const endBalanceArray =
    amortizationData &&
    amortizationData.allAmortizationData &&
    amortizationData.allAmortizationData.amortizationTable.data &&
    amortizationData.allAmortizationData.amortizationTable.data.map((row) =>
      parseNumber(row[endBalanceIndex])
    );

  const monthsArrayWithNoSnowBall =
    amortizationDataWithNoSnowball &&
    amortizationDataWithNoSnowball.amortizationTable.data &&
    amortizationDataWithNoSnowball.amortizationTable.data.map(
      (row) => row[monthIndex]
    );
  const endBalanceArrayWithNoSnowBall =
    amortizationDataWithNoSnowball &&
    amortizationDataWithNoSnowball.amortizationTable.data &&
    amortizationDataWithNoSnowball.amortizationTable.data.map((row) =>
      parseNumber(row[endBalanceIndex])
    );
  // const data = {
  //   labels,
  //   datasets: [
  //     {
  //       label: "Total Balance",
  //       data: totalBalanceData || [],
  //       fill: true,
  //       backgroundColor: "#399484",
  //       borderColor: "#399484",
  //       tension: 0.3,
  //     },
  //     {
  //       label: "With Extra Payments",
  //       data: totalPaymentData || [],
  //       fill: true,
  //       backgroundColor: "#707DC1",
  //       borderColor: "#707DC1",
  //       tension: 0.3,
  //     },
  //   ],
  // };

  const data = {
    labels: monthsArrayWithNoSnowBall || [],
    datasets: [
      {
        label: "With Extra Payments",
        data: endBalanceArray || [],
        fill: true,
        backgroundColor: "#399484",
        borderColor: "#399484",
        tension: 0.3,
      },
      {
        label: "Total Balance",
        data: endBalanceArrayWithNoSnowBall || [],
        fill: true,

        backgroundColor: "#707DC1",
        borderColor: "#707DC1",
        tension: 0.3,
      },
    ],
  };

  return (
    <div className="debt-card-chart" style={{ position: "relative" }}>
      {" "}
      <div>
        <Line
          data={data}
          height={80}
          options={{
            legend: {
              display: true,
              //   labels: {
              //     fontColor: "white",
              //   },
            },
            tooltips: {
              callbacks: {
                label: function (tooltipItem, chartData) {
                  // Get dataset label
                  const datasetLabel =
                    chartData.datasets[tooltipItem.datasetIndex].label || "";
                  // Get value
                  const value = tooltipItem.yLabel;
                  // Format to 2 decimals
                  const formattedValue = parseFloat(value)
                    .toFixed(2)
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  return `${datasetLabel}: $${formattedValue}`;
                },
              },
            },
            scales: {
              xAxes: [
                {
                  gridLines: {
                    color: "rgba(0, 0, 0, 0)",
                  },
                  ticks: {
                    // fontColor: "white",
                    // stepSize: 1,
                    beginAtZero: true,
                  },
                },
              ],
              yAxes: [
                {
                  gridLines: {
                    color: "rgba(0, 0, 0, 0)",
                  },
                  ticks: {
                    // fontColor: "white",
                    // stepSize: 1,
                    beginAtZero: true,
                    callback: function (value) {
                      return new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(value);
                    },
                  },
                },
              ],
            },
            plugins: {},
          }}
        />
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};
